import type { SchemaColumn, SchemaField } from '@cli-types/core-engine/schema.js'

export function fieldHasMediaCompanion(column: SchemaColumn, fields: SchemaField[]): boolean {
  const field = fields.find((item) => item.name === column.accessorKey)
  return field?.type === 'image' || field?.type === 'media' || field?.type === 'video'
}
